import { keyBy } from 'lodash-es'
import { OrderOwnerContract } from 'models'
import { useCallback, useMemo } from 'react'
import { getOrderName } from 'views/Sale/hooks/useOrderDetail'
export const ASSIGN_TAG = {
    shared: 'Shared',
    split: 'Split',
    allBill: 'All Bill',
}
export interface SelectableOrder {
    label: string
    value: string
}
export const useAssignTo = ({
    relatedOrders,
}: {
    relatedOrders: OrderOwnerContract[]
}) => {
    const selectableOrders = useMemo(() => {
        return relatedOrders
            .filter((a) => !a.isVoid && !a.isPaid)
            .map((order) => ({
                label: getOrderName(order),
                value: order.orderID ?? '',
            }))
    }, [relatedOrders])
    const orderNameMap = useMemo(() => {
        return keyBy(selectableOrders, 'value')
    }, [selectableOrders])

    const getAssignDetails = useCallback(
        (assignTo: string[]) => {
            if (assignTo.length === 0) return ASSIGN_TAG.shared
            else
                return (
                    assignTo?.map(
                        (v) => orderNameMap?.[v]?.label ?? ASSIGN_TAG.shared,
                    ) ?? []
                ).join(', ')
        },
        [orderNameMap],
    )
    const getTagLabel = useCallback(
        (assignTo: string[]): string => {
            if (!assignTo || assignTo.length === 0) return ASSIGN_TAG.shared
            else if (assignTo.length === 1)
                return orderNameMap?.[assignTo[0]]?.label ?? ASSIGN_TAG.shared
            else if (assignTo.length === selectableOrders.length)
                return ASSIGN_TAG.allBill
            return ASSIGN_TAG.split
        },
        [orderNameMap, selectableOrders.length],
    )
    return { selectableOrders, orderNameMap, getTagLabel, getAssignDetails }
}
